module.exports = __webpack_public_path__ + "static/assets/8e3b84713dcfc2ab54db15f0d03011a6.svg";